export const SHELTER_CREDENTIAL_TYPES = [
  'PetszelConnectShelterAdmin',
  'PetszelConnectShelterSiteAdmin',
  'PetszelConnectShelterStaff',
  'PetszelConnectShelterManager',
  'PetszelConnectShelterMedicalStaff',
  'PetszelConnectShelterBehaviorStaff',
  'PetszelConnectShelterMarketingStaff',
  'PetszelConnectShelterCustomerServiceStaff',
  'PetszelConnectShelterViewOnlyStaff',
] as const;

export type ShelterCredentialType = (typeof SHELTER_CREDENTIAL_TYPES)[number];

export function normalizeCredentialTypes(
  credentialType: string | string[] | null | undefined,
): string[] {
  if (!credentialType) {
    return [];
  }

  return Array.isArray(credentialType) ? credentialType : [credentialType];
}

export function hasShelterCredential(
  credentialType: string | string[] | null | undefined,
): boolean {
  const credentialTypes = normalizeCredentialTypes(credentialType);

  return credentialTypes.some((credential) =>
    SHELTER_CREDENTIAL_TYPES.includes(credential as ShelterCredentialType),
  );
}

export function isShelterCredential(
  credentialType: string | null | undefined,
): boolean {
  if (!credentialType) {
    return false;
  }

  return SHELTER_CREDENTIAL_TYPES.includes(
    credentialType as ShelterCredentialType,
  );
}